import React, {useEffect, useState} from 'react';
import {Flex, Form, Input, message, Select, Switch} from "antd";
import classes from "../../Courses/CreateCourse/CreateCourse.module.css";
import BlockLoading from "../../../../../components/LoadingComponents/BlockLoading";
import FormItem from "antd/es/form/FormItem";
import IntlMessage, {IntlMessageText} from "../../../../../components/IntlMessage/IntlMessage";
import GreyButton from "../../../../../components/UI/Buttons/GreyButton";
import {clrs} from "../../../../../constants/colors";
import {useDispatch, useSelector} from "react-redux";
import InputMask from "react-input-mask";
import {getUserByToken} from "../../../../../store/slices/userSlice";
import FullLoading from "../../../../../components/LoadingComponents/FullLoading";
import UserService from "../../../../../services/UserService";
import {CheckOutlined, CloseOutlined} from "@ant-design/icons";

const cities = [
    { value: "abay", ru: "Абай", kz: "Абай", label: "Абай" },
    { value: "akkol", ru: "Акколь", kz: "Ақкөл", label: "Акколь" },
    { value: "aksay", ru: "Аксай", kz: "Ақсай", label: "Аксай" },
    { value: "aksu", ru: "Аксу", kz: "Ақсу", label: "Аксу" },
    { value: "aktau", ru: "Актау", kz: "Ақтау", label: "Актау" },
    { value: "aktobe", ru: "Актобе", kz: "Ақтөбе", label: "Актобе" },
    { value: "alataw", ru: "Алатау", kz: "Алатау", label: "Алатау" },
    { value: "alga", ru: "Алга", kz: "Алға", label: "Алга" },
    { value: "almaty", ru: "Алматы", kz: "Алматы", label: "Алматы" },
    { value: "altai", ru: "Алтай", kz: "Алтай", label: "Алтай" },
    { value: "aral", ru: "Аральск", kz: "Арал", label: "Аральск" },
    { value: "arkalyk", ru: "Аркалык", kz: "Арқалық", label: "Аркалык" },
    { value: "arys", ru: "Арыс", kz: "Арыс", label: "Арыс" },
    { value: "astana", ru: "Астана", kz: "Астана", label: "Астана" },
    { value: "atbasar", ru: "Атбасар", kz: "Атбасар", label: "Атбасар" },
    { value: "atyrau", ru: "Атырау", kz: "Атырау", label: "Атырау" },
    { value: "ayagoz", ru: "Аягоз", kz: "Аягөз", label: "Аягоз" },
    { value: "baikonur", ru: "Байконыр", kz: "Байқоңыр", label: "Байконыр" },
    { value: "balkhash", ru: "Балхаш", kz: "Балқаш", label: "Балхаш" },
    { value: "bulaevo", ru: "Булаево", kz: "Булаев", label: "Булаево" },
    { value: "derzhavinsk", ru: "Державинск", kz: "Державин", label: "Державинск" },
    { value: "ereimentau", ru: "Ерейментау", kz: "Ерейментау", label: "Ерейментау" },
    { value: "esik", ru: "Есик", kz: "Есік", label: "Есик" },
    { value: "esil", ru: "Есиль", kz: "Есіл", label: "Есиль" },
    { value: "zhanaozen", ru: "Жанаозен", kz: "Жаңаөзен", label: "Жанаозен" },
    { value: "zhanatas", ru: "Жанатас", kz: "Жаңатас", label: "Жанатас" },
    { value: "zharkent", ru: "Жаркент", kz: "Жаркент", label: "Жаркент" },
    { value: "zhezkazgan", ru: "Жезказган", kz: "Жезқазған", label: "Жезказган" },
    { value: "zhem", ru: "Жем", kz: "Жем", label: "Жем" },
    { value: "zhetysai", ru: "Жетысай", kz: "Жетысай", label: "Жетысай" },
    { value: "zhitikara", ru: "Житикара", kz: "Жітіқара", label: "Житикара" },
    { value: "zaisan", ru: "Зайсан", kz: "Зайсан", label: "Зайсан" },
    { value: "kazalinsk", ru: "Казалинск", kz: "Қазалинск", label: "Казалинск" },
    { value: "kandyagash", ru: "Кандыагаш", kz: "Кандыағаш", label: "Кандыагаш" },
    { value: "karaganda", ru: "Караганда", kz: "Қарағанды", label: "Караганда" },
    { value: "karazhal", ru: "Каражал", kz: "Қаражал", label: "Каражал" },
    { value: "karatau", ru: "Каратау", kz: "Қаратау", label: "Каратау" },
    { value: "karkaralinsk", ru: "Каркаралинск", kz: "Қарқаралы", label: "Каркаралинск" },
    { value: "kaskelen", ru: "Каскелен", kz: "Қаскелең", label: "Каскелен" },
    { value: "kentau", ru: "Кентау", kz: "Кентау", label: "Кентау" },
    { value: "kokchetau", ru: "Кокшетау", kz: "Көкшетау", label: "Кокшетау" },
    { value: "konaev", ru: "Конаев", kz: "Қонаев", label: "Конаев" },
    { value: "kostanay", ru: "Костанай", kz: "Қостанай", label: "Костанай" },
    { value: "koshy", ru: "Косшы", kz: "Қосшы", label: "Косшы" },
    { value: "kulsary", ru: "Кулсары", kz: "Құлсары", label: "Кулсары" },
    { value: "kurchatov", ru: "Курчатов", kz: "Курчатов", label: "Курчатов" },
    { value: "kyzylorda", ru: "Кызылорда", kz: "Қызылорда", label: "Кызылорда" },
    { value: "lengir", ru: "Ленгер", kz: "Леңгір", label: "Ленгер" },
    { value: "lisakovsk", ru: "Лисаковск", kz: "Лисаковск", label: "Лисаковск" },
    { value: "makinsk", ru: "Макинск", kz: "Макинск", label: "Макинск" },
    { value: "mamlutka", ru: "Мамлютка", kz: "Мамлют", label: "Мамлютка" },
    { value: "pavlodar", ru: "Павлодар", kz: "Павлодар", label: "Павлодар" },
    { value: "petropavlovsk", ru: "Петропавловск", kz: "Петропавл", label: "Петропавловск" },
    { value: "priozersk", ru: "Приозёрск", kz: "Приозер", label: "Приозёрск" },
    { value: "ridder", ru: "Риддер", kz: "Риддер", label: "Риддер" },
    { value: "rudny", ru: "Рудный", kz: "Рудный", label: "Рудный" },
    { value: "saran", ru: "Сарань", kz: "Саран", label: "Сарань" },
    { value: "sarkand", ru: "Сарканд", kz: "Сарқант", label: "Сарканд" },
    { value: "saryagash", ru: "Сарыагаш", kz: "Сарыағаш", label: "Сарыагаш" },
    { value: "satpaev", ru: "Сатпаев", kz: "Сәтбаев", label: "Сатпаев" },
    { value: "semey", ru: "Семей", kz: "Семей", label: "Семей" },
    { value: "sergeevka", ru: "Сергеевка", kz: "Сергеевка", label: "Сергеевка" },
    { value: "serebryansk", ru: "Серебрянск", kz: "Серебрянск", label: "Серебрянск" },
    { value: "stepnogorsk", ru: "Степногорск", kz: "Степногорск", label: "Степногорск" },
    { value: "stepnyak", ru: "Степняк", kz: "Степняк", label: "Степняк" },
    { value: "taiynsha", ru: "Тайынша", kz: "Тайынша", label: "Тайынша" },
    { value: "talgar", ru: "Талгар", kz: "Талгар", label: "Талгар" },
    { value: "taldykorgan", ru: "Талдыкорган", kz: "Талдыкорған", label: "Талдыкорган" },
    { value: "taraz", ru: "Тараз", kz: "Тараз", label: "Тараз" },
    { value: "tekeli", ru: "Текели", kz: "Текели", label: "Текели" },
    { value: "temir", ru: "Темир", kz: "Темір", label: "Темир" },
    { value: "temirtau", ru: "Темиртау", kz: "Теміртау", label: "Темиртау" },
    { value: "tobyl", ru: "Тобыл", kz: "Тобыл", label: "Тобыл" },
    { value: "turkestan", ru: "Туркестан", kz: "Түркістан", label: "Туркестан" },
    { value: "uralsk", ru: "Уральск", kz: "Орал", label: "Уральск" },
    { value: "ust-kamenogorsk", ru: "Усть-Каменогорск", kz: "Өскемен", label: "Усть-Каменогорск" },
    { value: "usharal", ru: "Ушарал", kz: "Үшарал", label: "Ушарал" },
    { value: "ushtobe", ru: "Уштобе", kz: "Үштөбе", label: "Уштобе" },
    { value: "fort-shevchenko", ru: "Форт‑Шевченко", kz: "Форт‑Шевченко", label: "Форт‑Шевченко" },
    { value: "khromtau", ru: "Хромтау", kz: "Хромтау", label: "Хромтау" },
    { value: "shalkar", ru: "Шалкар", kz: "Шалқар", label: "Шалкар" },
    { value: "shar", ru: "Шар", kz: "Шар", label: "Шар" },
    { value: "shardara", ru: "Шардара", kz: "Шардара", label: "Шардара" },
    { value: "shakhtinsk", ru: "Шахтинск", kz: "Шахтинск", label: "Шахтинск" },
    { value: "shemonaikha", ru: "Шемонаиха", kz: "Шемонаиха", label: "Шемонаиха" },
    { value: "shu", ru: "Шу", kz: "Шу", label: "Шу" },
    { value: "shymkent", ru: "Шымкент", kz: "Шымкент", label: "Шымкент" },
    { value: "shchuchinsk", ru: "Щучинск", kz: "Щучинск", label: "Щучинск" },
    { value: "ekibastuz", ru: "Экибастуз", kz: "Екібастұз", label: "Экибастуз" },
    { value: "emba", ru: "Эмба", kz: "Ембі", label: "Эмба" }
];

const banks = [
    {
        value: "kaspi",
        ru: "АО «Kaspi Bank»",
        kz: "«Kaspi Bank» АҚ",
        label: "АО «Kaspi Bank»"
    },
    {
        value: "jusan",
        ru: "АО «Jusan Bank»",
        kz: "«Jusan Bank» АҚ",
        label: "АО «Jusan Bank»"
    },
    {
        value: "halyk",
        ru: "АО «Народный банк Казахстана»",
        kz: "«Қазақстан Халық банкі» АҚ",
        label: "АО «Народный банк Казахстана»"
    }
];

const departments = [
    {
        value: "Департамент вычислений и науки о данных",
        label: "Департамент вычислений и науки о данных"
    },
    {
        value: "Департамент компьютерной инженерии",
        label: "Департамент компьютерной инженерии"
    },
    {
        value: "Департамент интеллектуальных систем и кибербезопасности",
        label: "Департамент интеллектуальных систем и кибербезопасности"
    },
    {
        value: "Департамент общеобразовательных дисциплин",
        label: "Департамент общеобразовательных дисциплин"
    },
    {
        value: "Школа креативной индустрии",
        label: "Школа креативной индустрии"
    },
    {
        value: "Школа цифрового государственного управления",
        label: "Школа цифрового государственного управления"
    },
    {
        value: "Центр компетенций и совершенства",
        label: "Центр компетенций и совершенства"
    }
];

const PersonalData = () => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();

    const firstName = Form.useWatch('firstName', form);
    const lastName = Form.useWatch('lastName', form);
    const middleName = Form.useWatch('middleName', form);
    const gender = Form.useWatch('gender', form);
    const password = Form.useWatch('password', form);
    const confirmPassword = Form.useWatch('confirmPassword', form);
    const birthDay = Form.useWatch('birthDay', form);
    const city = Form.useWatch('city', form);
    const district = Form.useWatch('district', form);
    const buildingNumber = Form.useWatch('buildingNumber', form);
    const apartmentNumber = Form.useWatch('apartmentNumber', form);
    const address = Form.useWatch('address', form);
    const addressKz = Form.useWatch('addressKz', form);
    const telNumber = Form.useWatch('telNumber', form);
    const iin = Form.useWatch('iin', form);
    const idCardNumber = Form.useWatch('idCardNumber', form);
    const idCardFromWhom = Form.useWatch('idCardFromWhom', form);
    const idCardDate = Form.useWatch('idCardDate', form);
    const firstNameInEnglish = Form.useWatch('firstNameInEnglish', form);
    const lastNameInEnglish = Form.useWatch('lastNameInEnglish', form);
    const bank = Form.useWatch('bank', form);
    const iban = Form.useWatch('iban', form);
    const position = Form.useWatch('position', form);
    const department = Form.useWatch('department', form);

    const fullNameParent = Form.useWatch('fullNameParent', form);
    const telNumberParent = Form.useWatch('telNumberParent', form);
    const iin_parent = Form.useWatch('iin_parent', form);
    const idCardNumber_parent = Form.useWatch('idCardNumber_parent', form);
    const idCardFromWhom_parent = Form.useWatch('idCardFromWhom_parent', form);
    const idCardDate_parent = Form.useWatch('idCardDate_parent', form);

    const [isTeacherInside, setIsTeacherInside] = useState(false)

    const [isLoadingCreate, setIsLoadingCreate] = useState(false);
    const {user, isLoading} = useSelector(state => state.user);

    useEffect(() => {
        if (user === null) {
            dispatch(getUserByToken());
        }
    }, []);

    useEffect(() => {
        if (city && district && buildingNumber) {
            const selected = cities.find(c => c.value === city);
            let fullAddress = `г. ${selected.ru}, ${district} ${buildingNumber}`;
            let fullAddressKz = `${selected.kz} қ., ${district} ${buildingNumber}`;
            if (apartmentNumber) {
                fullAddress += `, ${apartmentNumber}`;
                fullAddressKz += `, ${apartmentNumber}`;
            }
            form.setFieldsValue({ address: fullAddress });
            form.setFieldsValue({ addressKz: fullAddressKz });
        }
    }, [city, district, buildingNumber, apartmentNumber]);

    const handleInputChange = (e, fieldName) => {
        const inputValue = e.target.value;
        const formattedInput = inputValue.split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
        form.setFieldsValue(
            {[fieldName]: formattedInput}
        );
    };

    function handleCreate() {
        form.validateFields()
            .then(async () => {
                message.loading(<IntlMessage id={'loading'}/>, 0);
                setIsLoadingCreate(true);
                // Очистка от лишних символов
                const cleanedTelNumber = telNumber?.replace(/\D/g, '').slice(0, 11) || '';
                const cleanedIin = iin?.replace(/\D/g, '').slice(0, 12) || '';
                const selectedBank = banks.find(c => c.value === bank);
                await UserService.editUser(user.id, firstName, lastName, middleName, firstNameInEnglish, lastNameInEnglish, gender, birthDay, address, addressKz, cleanedIin, cleanedTelNumber, idCardNumber, idCardDate, idCardFromWhom, fullNameParent, telNumberParent, iin_parent, idCardNumber_parent, idCardFromWhom_parent, idCardDate_parent, selectedBank?.ru, selectedBank?.kz, iban, department, position)
                    .then(() => {
                        message.destroy();
                        message.success(<IntlMessage id={'success'}/>, 5);
                        form.resetFields();
                        dispatch(getUserByToken());
                    })
                    .catch(() => {
                        message.destroy();
                        message.error(<IntlMessage id={'error'}/>, 5);
                    })
                    .finally(() => {
                        setIsLoadingCreate(false);
                    })
            })
            .catch(() => {
                console.log("Validation error!")
            })
    }

    if (isLoading) {
        return <FullLoading/>;
    }


    return (
        <Form form={form} className={classes.form}
              initialValues={{
                  firstName: user.profile?.firstName,
                  middleName: user.profile?.middleName,
                  lastName: user.profile?.lastName,
                  firstNameInEnglish: user.profile?.firstNameInEnglish,
                  lastNameInEnglish: user.profile?.lastNameInEnglish,
                  gender: user.profile?.gender,
                  birthDay: user.profile?.birthDay,
                  address: user.profile?.address,
                  addressKz: user.profile?.addressKz,
                  telNumber: user.profile?.telNumber,
                  iin: user.profile?.iin,
                  idCardNumber: user.profile?.idCardNumber,
                  idCardFromWhom: user.profile?.idCardFromWhom || user.profile?.idCardFromWhom == '' ? user.profile?.idCardFromWhom : "МВД РК",
                  idCardDate: user.profile?.idCardDate,
                  fullNameParent: user.profile?.parentFullName,
                  telNumberParent: user.profile?.parentTelNumber,
                  iin_parent: user.profile?.parentIin,
                  idCardNumber_parent: user.profile?.parentIdCardNumber,
                  idCardFromWhom_parent: user.profile?.parentIdCardFromWhom || user.profile?.parentIdCardFromWhom == '' ? user.profile?.parentIdCardFromWhom : "МВД РК",
                  idCardDate_parent: user.profile?.parentIdCardDate,
                  bank: user.profile?.bank,
                  iban: user.profile?.iban,
                  department: user.profile?.department,
                  position: user.profile?.position,
              }}>
            <BlockLoading isLoading={isLoadingCreate}/>
            <FormItem rules={[{
                required: true,
                message: <IntlMessage id={'requiredField'}/>,
            },
            ]} label={<IntlMessage id={'firstName'}/>} labelCol={{span: 24}} className={classes.formInputBlock}
                      name="firstName">
                <Input onChange={(e) => {
                    handleInputChange(e, "firstName")
                }} rootClassName={classes.formInput} placeholder={IntlMessageText.getText({id: "firstName"})}/>
            </FormItem>
            <FormItem rules={[{
                required: true,
                message: <IntlMessage id={'requiredField'}/>,
            },
            ]} label={<IntlMessage id={'lastName'}/>} labelCol={{span: 24}} className={classes.formInputBlock}
                      name="lastName">
                <Input onChange={(e) => {
                    handleInputChange(e, "lastName")
                }} rootClassName={classes.formInput} placeholder={IntlMessageText.getText({id: "lastName"})}/>
            </FormItem>
            <FormItem rules={[{
                required: false,
                message: <IntlMessage id={'requiredField'}/>,
            },
            ]} label={<IntlMessage id={'middleName'}/>} labelCol={{span: 24}} className={classes.formInputBlock}
                      name="middleName">
                <Input onChange={(e) => {
                    handleInputChange(e, "middleName")
                }} rootClassName={classes.formInput} placeholder={IntlMessageText.getText({id: "middleName"})}/>
            </FormItem>
            <FormItem rules={[{
                required: true,
                message: <IntlMessage id={'requiredField'}/>,
            },
            ]} label={<IntlMessage id={'firstNameInEnglish'}/>} labelCol={{span: 24}}
                      className={classes.formInputBlock} name="firstNameInEnglish">
                <Input onChange={(e) => {
                    handleInputChange(e, "firstNameInEnglish")
                }} rootClassName={classes.formInput}/>
            </FormItem>
            <FormItem rules={[{
                required: true,
                message: <IntlMessage id={'requiredField'}/>,
            },
            ]} label={<IntlMessage id={'lastNameInEnglish'}/>} labelCol={{span: 24}}
                      className={classes.formInputBlock} name="lastNameInEnglish">
                <Input onChange={(e) => {
                    handleInputChange(e, "lastNameInEnglish")
                }}
                       rootClassName={classes.formInput}/>
            </FormItem>
            <FormItem rules={[{
                required: true,
                message: <IntlMessage id={'requiredField'}/>,
            },
            ]} label={<IntlMessage id={'gender'}/>} labelCol={{span: 24}} className={classes.formInputBlock}
                      name="gender">
                <Select options={[
                    { value: 'M', label: 'M' },
                    { value: 'W', label: 'Ж' }
                ]}/>
            </FormItem>
            <FormItem rules={[{
                required: true,
                message: <IntlMessage id={'requiredField'}/>,
            },
            ]} label={<IntlMessage id={'birthDay'}/>} labelCol={{span: 24}} className={classes.formInputBlock}
                      name="birthDay">
                <Input type={'date'} rootClassName={classes.formInput}/>
            </FormItem>
            {
                user?.role.roleName === 'teacher' &&
                <>
                    <FormItem rules={[{
                        required: !(user?.profile?.address && user?.profile?.addressKz),
                        message: <IntlMessage id={'requiredField'}/>,
                    },
                    ]} label={<IntlMessage id={'city'}/>} labelCol={{span: 24}} className={classes.formInputBlock}
                              name="city">
                        <Select showSearch optionFilterProp="label" options={cities} />
                    </FormItem>
                    <FormItem rules={[{
                        required: !(user?.profile?.address && user?.profile?.addressKz),
                        message: <IntlMessage id={'requiredField'}/>,
                    },
                    ]} label={<IntlMessage id={'district'}/>} labelCol={{span: 24}} className={classes.formInputBlock}
                              name="district">
                        <Input rootClassName={classes.formInput} placeholder={"Улы Дала"}/>
                    </FormItem>
                    <FormItem rules={[{
                        required: !(user?.profile?.address && user?.profile?.addressKz),
                        message: <IntlMessage id={'requiredField'}/>,
                    },
                    ]} label={<IntlMessage id={'buildingNumber'}/>} labelCol={{span: 24}}
                              className={classes.formInputBlock}
                              name="buildingNumber">
                        <Input rootClassName={classes.formInput} placeholder={"11/3"}/>
                    </FormItem>
                    <FormItem label={<IntlMessage id={'apartmentNumber'}/>} labelCol={{span: 24}}
                              className={classes.formInputBlock}
                              name="apartmentNumber">
                        <Input rootClassName={classes.formInput} placeholder={"178"}/>
                    </FormItem>
                </>
            }
            <FormItem rules={[{
                required: true,
                message: <IntlMessage id={'requiredField'}/>,
            },
            ]} label={<IntlMessage id={'address'}/>} labelCol={{span: 24}} className={classes.formInputBlock}
                      name="address">
                <Input rootClassName={classes.formInput} disabled={user?.role.roleName === 'teacher'}/>
            </FormItem>
            {
                user?.role.roleName === 'teacher' &&
                <FormItem rules={[{
                    required: user?.role.roleName === 'teacher',
                    message: <IntlMessage id={'requiredField'}/>,
                },
                ]} label={<IntlMessage id={'addressKz'}/>} labelCol={{span: 24}} className={classes.formInputBlock}
                          name="addressKz">
                    <Input rootClassName={classes.formInput}/>
                </FormItem>
            }
            <FormItem rules={[{
                required: true,
                message: <IntlMessage id={'requiredField'}/>,
            },
            ]} label={<IntlMessage id={'telNumber'}/>} labelCol={{span: 24}} className={classes.formInputBlock}
                      name="telNumber">
                <InputMask
                    mask="+9 (999) 999-9999"
                    className={classes.formInput}
                >
                    {(inputProps) => <Input{...inputProps} />}
                </InputMask>
            </FormItem>
            <FormItem rules={[{
                required: true,
                message: <IntlMessage id={'requiredField'}/>,
            },
            ]} label={<IntlMessage id={'iin'}/>} labelCol={{span: 24}} className={classes.formInputBlock}
                      name="iin">
                <InputMask
                    mask="999999999999"
                    className={classes.formInput}
                >
                    {(inputProps) => <Input{...inputProps} />}
                </InputMask>
            </FormItem>
            <FormItem rules={[{
                required: true,
                message: <IntlMessage id={'requiredField'}/>,
            },
            ]} label={<IntlMessage id={'idCardNumber'}/>} labelCol={{span: 24}}
                      className={classes.formInputBlock} name="idCardNumber">
                <Input rootClassName={classes.formInput}/>
            </FormItem>
            <FormItem rules={[{
                required: idCardNumber,
                message: <IntlMessage id={'requiredField'}/>,
            },
            ]} label={<IntlMessage id={'idCardFromWhom'}/>} labelCol={{span: 24}}
                      className={classes.formInputBlock} name="idCardFromWhom">
                <Input rootClassName={classes.formInput}/>
            </FormItem>
            <FormItem rules={[{
                required: idCardNumber,
                message: <IntlMessage id={'requiredField'}/>,
            },
            ]} label={<IntlMessage id={'idCardDate'}/>} labelCol={{span: 24}} className={classes.formInputBlock}
                      name="idCardDate">
                <Input type={'date'} rootClassName={classes.formInput}/>
            </FormItem>
            {
                user?.role.roleName === 'teacher' &&
                <>
                    <Flex gap={"small"}>
                        <IntlMessage id={"aituStuff"}/>
                        <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />} checked={isTeacherInside} onClick={() => setIsTeacherInside(!isTeacherInside)} />
                    </Flex>
                    {
                        isTeacherInside &&
                        <FormItem rules={[{
                            required: isTeacherInside,
                            message: <IntlMessage id={'requiredField'}/>,
                        },
                        ]} label={<IntlMessage id={'department'}/>} labelCol={{span: 24}}
                                  className={classes.formInputBlock}
                                  name="department">
                            <Select options={departments}/>
                        </FormItem>
                    }
                    {
                        isTeacherInside &&
                        <FormItem rules={[{
                            required: isTeacherInside,
                            message: <IntlMessage id={'requiredField'}/>,
                        },
                        ]} label={<IntlMessage id={'position'}/>} labelCol={{span: 24}}
                                  className={classes.formInputBlock}
                                  name="position">
                            <Input rootClassName={classes.formInput} placeholder={"Специалист, Менеджер"}/>
                        </FormItem>
                    }
                    <FormItem rules={[{
                        required: user?.role.roleName === 'teacher',
                        message: <IntlMessage id={'requiredField'}/>,
                    },
                    ]} label={<IntlMessage id={'bank'}/>} labelCol={{span: 24}} className={classes.formInputBlock}
                              name="bank">
                        <Select options={banks}/>
                    </FormItem>
                    <FormItem rules={[{
                        required: user?.role.roleName === 'teacher',
                        message: <IntlMessage id={'requiredField'}/>,
                    },
                    ]} label={<IntlMessage id={'iban'}/>} labelCol={{span: 24}} className={classes.formInputBlock}
                              name="iban">
                        <Input rootClassName={classes.formInput} placeholder={"KZ0000000000000"}/>
                    </FormItem>
                </>
            }
            {
                user?.role.roleName === 'student' &&
                <>
                    <FormItem rules={[{
                        required: false,
                        message: <IntlMessage id={'requiredField'}/>,
                    },
                    ]} label={<IntlMessage id={'fullNameParentInDoc'}/>} labelCol={{span: 24}}
                              className={classes.formInputBlock} name="fullNameParent">
                        <Input onChange={(e) => {
                            handleInputChange(e, "fullNameParent")
                        }}
                               rootClassName={classes.formInput}/>
                    </FormItem>
                    <FormItem rules={[{
                        required: false,
                        message: <IntlMessage id={'requiredField'}/>,
                    },
                    ]} label={<IntlMessage id={'telNumberParent'}/>} labelCol={{span: 24}}
                              className={classes.formInputBlock} name="telNumberParent">
                        <InputMask
                            mask="+9 (999) 999-9999"

                            className={classes.formInput}
                        >
                            {(inputProps) => <Input
                                {...inputProps} />}
                        </InputMask>
                    </FormItem>
                    <FormItem rules={[{
                        required: false,
                        message: <IntlMessage id={'requiredField'}/>,
                    },
                    ]} label={<IntlMessage id={'iin_parent'}/>} labelCol={{span: 24}}
                              className={classes.formInputBlock} name="iin_parent">
                        <Input
                            rootClassName={classes.formInput}/>
                    </FormItem>
                    <FormItem rules={[{
                        required: false,
                        message: <IntlMessage id={'requiredField'}/>,
                    },
                    ]} label={<IntlMessage id={'idCardNumber_parent'}/>} labelCol={{span: 24}}
                              className={classes.formInputBlock} name="idCardNumber_parent">
                        <Input
                            rootClassName={classes.formInput}/>
                    </FormItem>
                    <FormItem rules={[{
                        required: false,
                        message: <IntlMessage id={'requiredField'}/>,
                    },
                    ]} label={<IntlMessage id={'idCardFromWhom_parent'}/>} labelCol={{span: 24}}
                              className={classes.formInputBlock} name="idCardFromWhom_parent">
                        <Input
                            rootClassName={classes.formInput}/>
                    </FormItem>
                    <FormItem rules={[{
                        required: false,
                        message: <IntlMessage id={'requiredField'}/>,
                    },
                    ]} label={<IntlMessage id={'idCardDate_parent'}/>} labelCol={{span: 24}}
                              className={classes.formInputBlock} name="idCardDate_parent">
                        <Input type={'date'}
                               rootClassName={classes.formInput}/>
                    </FormItem>
                </>
            }
            <FormItem className={classes.formInputBlock}>
                <Flex align={"flex-start"} justify={"flex-start"} gap={20} style={{width: "100%"}}>
                    <GreyButton onClick={handleCreate} backgroundColor={clrs.blackerBlue}
                                fontColor={clrs.white}><IntlMessage id={'edit'}/></GreyButton>
                </Flex>
            </FormItem>
        </Form>
    );
};

export default PersonalData;